import React, { useEffect } from 'react';
import { Layout } from 'antd';
import { Outlet, useSearchParams, useNavigate } from 'react-router-dom';
import Fhead from './_head';
import Foot from './_foot';


import './index.scss';

const { Header, Content } = Layout;
const headerStyle = {
    textAlign: 'center',
    color: '#fff',
    height: 64,
    paddingInline: 48,
    lineHeight: '64px',
    backgroundColor: 'rgba(174,252,169,0.02)',
};
const contentStyle = {
    textAlign: 'center',
    backgroundColor: '#fafafa',
    minHeight: '200px',

};






const Am = () => {

    const navigate = useNavigate()
    const [tno] = useSearchParams()
    const tn = tno.get("t")
    useEffect(() => {
        if (tn !== null) {
            localStorage.setItem('promoter', tn)//把推广者Id写入 方便调用
            navigate('/') //隐藏推广链接
        }
    }, [navigate, tn])

    return <>

        <Header style={headerStyle}><Fhead /></Header>
        <Content style={contentStyle}><Outlet></Outlet></Content>

       
        <Foot></Foot>

    </>

}
export default Am